const user = {
    username_already_in_use: 'Tên đăng nhập này đã được sử dụng.',
    username_starts_with_number: 'Tên đăng nhập không được bắt đầu bằng số.',
    username_invalid_charset_hard: 'Tên đăng nhập chỉ được chứa chữ, số, gạch dưới, gạch ngang và dấu chấm.',
    username_too_short: 'Tên đăng nhập quá ngắn.',
    username_too_long: 'Tên đăng nhập quá dài.',
    username_uppercase_not_allowed: 'Tên đăng nhập không được chứa chữ hoa.',
    username_lowercase_not_allowed: 'Tên đăng nhập không được chứa chữ thường.',
    username_numbers_not_allowed: 'Tên đăng nhập không được chứa số.',
    username_underscore_not_allowed: 'Tên đăng nhập không được chứa gạch dưới.',
    email_already_in_use: 'Email này đã gắn với một tài khoản hiện có.',
    phone_already_in_use: 'Số điện thoại này đã gắn với một tài khoản hiện có.',
    invalid_email: 'Địa chỉ email không hợp lệ.',
    invalid_phone: 'Số điện thoại không hợp lệ.',
    email_not_exist: 'Địa chỉ email chưa được đăng ký.',
    phone_not_exist: 'Số điện thoại chưa được đăng ký.',
    identity_not_exist: 'Tài khoản mạng xã hội chưa được đăng ký.',
    sso_identity_not_exist: 'Tài khoản SSO doanh nghiệp chưa được đăng ký.',
    identity_already_in_use: 'Tài khoản mạng xã hội này đã gắn với một tài khoản hiện có.',
    social_account_exists_in_profile: 'Bạn đã liên kết tài khoản mạng xã hội này rồi.',
    cannot_delete_self: 'Bạn không thể xóa chính mình.',
    sign_up_method_not_enabled: 'Phương thức đăng ký này chưa được bật.',
    sign_in_method_not_enabled: 'Phương thức đăng nhập này chưa được bật.',
    same_password: 'Mật khẩu mới không được giống mật khẩu cũ.',
    password_required_in_profile: 'Bạn cần đặt mật khẩu trước khi đăng nhập.',
    new_password_required_in_profile: 'Bạn cần đặt mật khẩu mới.',
    password_exists_in_profile: 'Hồ sơ của bạn đã có mật khẩu.',
    username_required_in_profile: 'Bạn cần đặt tên đăng nhập trước khi đăng nhập.',
    username_exists_in_profile: 'Hồ sơ của bạn đã có tên đăng nhập.',
    email_required_in_profile: 'Bạn cần thêm địa chỉ email trước khi đăng nhập.',
    email_exists_in_profile: 'Hồ sơ của bạn đã gắn với một địa chỉ email.',
    phone_required_in_profile: 'Bạn cần thêm số điện thoại trước khi đăng nhập.',
    phone_exists_in_profile: 'Hồ sơ của bạn đã gắn với một số điện thoại.',
    email_or_phone_required_in_profile: 'Bạn cần thêm địa chỉ email hoặc số điện thoại trước khi đăng nhập.',
    suspended: 'Tài khoản này đã bị tạm ngưng.',
    user_not_exist: 'Người dùng với {{ identifier }} không tồn tại.',
    missing_profile: 'Bạn cần cung cấp thêm thông tin trước khi đăng nhập.',
    role_exists: 'Vai trò có id {{roleId}} đã được thêm vào người dùng này',
    invalid_role_type: 'Loại vai trò không hợp lệ, không thể gán vai trò machine-to-machine cho người dùng.',
    suggest_mfa: 'Để bảo mật tài khoản tốt hơn, chúng tôi khuyên bạn nên gắn MFA cho tài khoản.',
    missing_mfa: 'Bạn cần gắn thêm MFA trước khi đăng nhập.',
    totp_already_in_use: 'TOTP đã được sử dụng.',
    backup_code_already_in_use: 'Mã dự phòng (backup code) đã được sử dụng.',
    password_algorithm_required: 'Cần có thuật toán mật khẩu.',
    password_and_digest: 'Bạn không thể vừa đặt mật khẩu dạng văn bản thuần vừa đặt password digest.',
    personal_access_token_name_exists: 'Tên personal access token đã tồn tại.',
    totp_secret_invalid: 'TOTP secret được cung cấp không hợp lệ.',
    wrong_backup_code_format: 'Định dạng mã dự phòng (backup code) không hợp lệ.',
    username_required: 'Tên đăng nhập là định danh bắt buộc, bạn không thể đặt thành null.',
    email_or_phone_required: 'Địa chỉ email hoặc số điện thoại là định danh bắt buộc, cần có ít nhất một trong hai.',
    last_sign_in_method_required: 'Bạn cần giữ lại ít nhất một định danh trong tài khoản.',
    email_required: 'Địa chỉ email là định danh bắt buộc, bạn không thể đặt thành null.',
    phone_required: 'Số điện thoại là định danh bắt buộc, bạn không thể đặt thành null.',
    enterprise_sso_identity_not_exists: 'Người dùng không có danh tính doanh nghiệp được liên kết với connector SSO có ID: {{ ssoConnectorId }}.',
    identity_not_exists_in_current_user: 'Danh tính được chỉ định không tồn tại trong tài khoản người dùng hiện tại. Vui lòng liên kết danh tính trước khi tiếp tục.',
    passkey_preferred: 'Tạo passkey để đơn giản hóa quá trình đăng nhập của bạn.',
};
export default Object.freeze(user);
